export default __webpack_public_path__ + "static/media/talent_main-section-logo-automatic-Dev-IT.4515e312.svg";